import PopupLogout from "components/popup-logout";
import React, { useEffect, useState } from "react";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import routes from "routes";
const TheHeader = () => {
  const [nav, setNav] = useState(false);
  const [active, setActive] = useState(null);
  const [namePage, setNamePage] = useState("Home");
  const navigate = useNavigate();
  const handleNav = () => {
    setNav(true);
    document.body.classList.add("modal-open");
  };
  const handleCloseNav = (e) => {
    setNav(false);
    document.body.classList.remove("modal-open");
  };

  const handleNavigate = (e) => {
    navigate(e);
    handleCloseNav();
  };
  useEffect(() => {
    if (window.location.pathname) {
      handleNavigate(window.location.pathname);
      setActive(window.location.pathname);
      console.log("window.location.pathname", window.location.pathname);
      if (window.location.pathname === "/") {
        document.title = "P/S - Kiểm Tra Răng AI";
      } else {
        document.title =
          "P/S - Kiểm Tra Răng AI" +
          `${namePage && " - " + namePage}`;
      }
    } else {
      handleNavigate("/");
      setActive("/");
      document.title = "P/S - Kiểm Tra Răng AI";
    }
  }, [window.location.pathname]);

  const getTitleHead = (e) => {
    var x = document.createElement("TITLE");
    var t = document.createTextNode("HTML DOM Objects");
    x.appendChild(t);
    document.head.appendChild(x);

    document.getElementById("demo").innerHTML = "You have ";
  };

  const location = useLocation();

  return (
    <>
      {location.pathname !== "/thongtinnguoidung" &&
        location.pathname !== "/game" && (
          <>
            <header>
              <a
                onClick={() => {
                  setActive("/");
                  handleNavigate("/");
                }}
                className="logo"
              >
                <img src="assets/img/logoBrand.png" alt="logo" />
              </a>
            </header>
            {nav && (
              <PopupLogout
                content="Đăng xuất"
                handleCloseNav={handleCloseNav}
              />
            )}
          </>
        )}
      {window.location.pathname === "/thongtinnguoidung" && (
        <div className="header">THÔNG TIN NGƯỜI TRÚNG THƯỞNG</div>
      )}
      {window.location.pathname === "/game" && ""}
    </>
  );
};

export default TheHeader;
